const topics = [
  { label: '#歌手2024总决赛', count: '128万讨论' },
  { label: '#奔跑吧笑点合集', count: '96万讨论' },
  { label: '#脱口秀爆梗', count: '203万讨论' },
  { label: '#街舞大神对决', count: '157万讨论' },
  { label: '#密室逃脱名场面', count: '89万讨论' },
  { label: '#向往的生活收官', count: '74万讨论' },
  { label: '#综艺神剪辑', count: '56万讨论' },
  { label: '#新综艺推荐', count: '43万讨论' },
  { label: '#综艺OST神曲', count: '38万讨论' },
  { label: '#极限挑战回归', count: '31万讨论' },
  { label: '#夏日综艺指南', count: '27万讨论' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            综艺圈正在热议的话题，加入讨论发现更多精彩
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, index) => (
            <a
              key={index}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer"
            >
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-[11px] text-foreground-500 group-hover:text-primary-500 whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}